import { useEffect, useRef, useState } from 'react';
import './Technical.css';

const DECISIONS = [
  { name: 'Local storage over cloud',       why: 'Your data lives on your phone — fast, reliable, and never waiting on a server.',                  tag: 'storage'      },
  { name: 'Background processing',          why: 'Heavy work happens quietly in the background. The app stays smooth no matter the document size.', tag: 'performance'  },
  { name: 'On-device intelligence',         why: 'Reading and understanding happens entirely on your phone — no data ever leaves.',                  tag: 'privacy'      },
  { name: 'Precise text reading',           why: 'Every character is read accurately, even in dense or mixed-language documents.',                  tag: 'accuracy'     },
  { name: 'Single app, all devices',        why: 'One consistent experience across all Android phones. Same quality, same feel, everywhere.',        tag: 'consistency'  },
];

const TERM_LINES = [
  { key: 'READ',    rest: 'invoice_march.pdf → ', val: '1,204 words found' },
  { key: 'SCAN',    rest: 'page_01 → Hindi detected · ', val: '98 characters' },
  { key: 'LANG',    rest: 'mixed languages · English + Hindi · ', ok: 'identified' },
  { key: 'TAG',     rest: 'category: finance · match: ', val: '96%' },
  { key: 'TAG',     rest: 'sub-tag: invoice · match: ', val: '91%' },
  { key: 'SAVE',    rest: 'document saved · index updated' },
  { key: 'STATUS',  rest: 'background task done · memory: ', ok: 'clear' },
  { key: 'STATUS',  rest: 'app: ', ok: 'ready' },
];

export default function Technical() {
  const termRef = useRef(null);
  const [visibleLines, setVisibleLines] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = termRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          TERM_LINES.forEach((_, i) => {
            setTimeout(() => setVisibleLines((prev) => prev + 1), i * 220);
          });
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="technical" id="technical">
      <div className="section-label reveal">Choices · Principles · Reasoning</div>
      <div className="technical-grid">
        <div className="tech-decisions">
          {DECISIONS.map((d, i) => (
            <div
              className="tech-decision reveal"
              key={i}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div>
                <div className="decision-name">{d.name}</div>
                <div className="decision-why">{d.why}</div>
              </div>
              <div className="decision-tag">{d.tag}</div>
            </div>
          ))}
        </div>

        <div className="tech-terminal">
          <div className="terminal-bar">
            <div className="t-dot" />
            <div className="t-dot" />
            <div className="t-dot" />
            <div className="terminal-label">tagpdf · runtime log</div>
          </div>
          <div className="terminal-body" ref={termRef}>
            {TERM_LINES.slice(0, visibleLines).map((l, i) => (
              <div className="t-line" key={i}>
                [<span className="t-key">{l.key}</span>]&nbsp;&nbsp;
                {l.rest}
                {l.val  && <span className="t-val">{l.val}</span>}
                {l.ok   && <span className="t-ok">{l.ok}</span>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
